import type { Product, Property } from "@/core/api/graphql/types";
import type { PreparedLineItemType } from "@/core/types";

export function ProductUtils() {
  function getProperty(product: Product | PreparedLineItemType, productName: string) {
    const property = product?.properties?.find((item: Property) => item.name === productName) ?? "";
    if (property) {
      return property.value;
    } else {
      return "-";
    }
  }

  const energyLabels = ["A", "A+", "A++", "A+++", "B", "C", "D", "E", "F", "G"];

  function getProductEneryLabelImage(product: Product) {
    const newType = getProperty(product, "energielabel_a_g_nieuw");
    const oldType = getProperty(product, "energielabel_a_g_oud");

    if (!energyLabels.includes(newType as string) || energyLabels.includes(oldType as string)) {
      return;
    }

    if (newType) {
      return `/static/images/energylabels/new/${newType}.png`;
    }

    if (oldType) {
      return `/static/images/energylabels/old/${oldType}.png`;
    }

    return undefined;
  }

  const customLabels = [
    "Aanbieding",
    "Binnenkortweeropvoorraad",
    "Bundelvoordeel",
    "Energiezuinig",
    "Extravoordeel",
    "Groenstekeuze",
    "Nieuw",
    "Uitlopendmodel",
    "Veldskeuze",
  ];

  function getProductCustomLabel(product: Product) {
    const tag = getProperty(product, "tags_website");

    if (!tag || !customLabels.includes(tag as string)) {
      return undefined;
    }

    return `/static/images/tags/${tag}.svg`;
  }

  return {
    getProperty,
    getProductEneryLabelImage,
    getProductCustomLabel,
  };
}
